import { render, staticRenderFns } from "./ItemChip.vue?vue&type=template&id=f0be3626&scoped=true"
import script from "./ItemChip.vue?vue&type=script&lang=js"
export * from "./ItemChip.vue?vue&type=script&lang=js"
import style0 from "./ItemChip.vue?vue&type=style&index=0&id=f0be3626&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0be3626",
  null
  
)

export default component.exports